"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Parser = _interopRequireDefault(require("@/components/FormGenerator/components/parser/Parser"));
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var systemFormConfigApi = _interopRequireWildcard(require("@/api/systemFormConfig.js"));
var systemSettingApi = _interopRequireWildcard(require("@/api/systemSetting.js"));
var _sms = require("@/api/sms");
var _validate = require("@/utils/validate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写手机号'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确!'));
      } else {
        callback();
      }
    };
    return {
      currentTab: 0,
      cTab: 0,
      installList: [{
        img: require('@/assets/imgs/wechat_h5.png'),
        name: '公众号',
        id: 65
      }, {
        img: require('@/assets/imgs/routine.png'),
        name: '小程序',
        id: 66
      }, {
        img: require('@/assets/imgs/app.png'),
        name: 'APP',
        id: 134
      }],
      checkArr: [],
      payConfigArr: [],
      siteConfigArr: [],
      applicationName: '',
      siteConfigName: '',
      payConfigName: '',
      checked: false,
      formConf: {
        content: {
          fields: []
        },
        id: null,
        render: false,
        isEdit: false
      },
      currentEditId: null,
      currentEditData: {},
      loading: false,
      disabled: true,
      passwordType: 'password',
      cutNUm: '获取验证码',
      canClick: true,
      formInline: {
        account: '',
        code: '',
        domain: '',
        phone: '',
        password: ''
      },
      ruleInline: {
        password: [{
          required: true,
          message: '请输入短信平台密码/token',
          trigger: 'blur'
        }],
        domain: [{
          required: true,
          message: '请输入网址域名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      }
    };
  },
  components: {
    parser: _Parser.default
  },
  mounted: function mounted() {
    this.handlerGetTreeList();
    this.getStep();
  },
  methods: {
    install: function install(i) {
      if (this.checkArr.includes(i)) {
        //includes()方法判断是否包含某一元素,返回true或false表示是否包含元素，对NaN一样有效
        //filter()方法用于把Array的某些元素过滤掉，filter()把传入的函数依次作用于每个元素，然后根据返回值是true还是false决定保留还是丢弃该元素：生成新的数组
        this.checkArr = this.checkArr.filter(function (ele) {
          return ele != i;
        });
      } else {
        this.checkArr.push(i);
        this.applicationName = this.checkArr[0].id.toString();
        if (this.checkArr.length) this.disabled = false;
      }
    },
    nextStep: function nextStep() {
      this.currentTab++;
      switch (this.currentTab) {
        case 1:
          if (this.checkArr.length) {
            this.handlerGetFormConfig(Number(this.applicationName));
          }
          break;
        case 2:
          this.payConfigName = this.payConfigArr[0].extra;
          if (this.payConfigArr.length) {
            this.handlerGetFormConfig(Number(this.payConfigName));
          }
          break;
        case 3:
          this.siteConfigName = this.siteConfigArr[0].extra;
          if (this.siteConfigArr.length) {
            this.handlerGetFormConfig(Number(this.siteConfigName));
          }
        default:
          break;
      }
      var data = {
        currentTab: this.currentTab,
        checkArr: this.checkArr,
        payConfigArr: this.payConfigArr,
        siteConfigArr: this.siteConfigArr
      };
      this.$cache.local.setJSON('step', data);
    },
    getStep: function getStep() {
      if (!this.$cache.local.has('step')) return;
      var data = this.$cache.local.getJSON('step');
      this.currentTab = data.currentTab ? data.currentTab : 0;
      this.checkArr = data.checkArr;
      this.payConfigArr = data.payConfigArr;
      this.siteConfigArr = data.siteConfigArr;
      if (this.checkArr.length) this.disabled = false;
      if (this.currentTab == 1) {
        this.applicationName = this.checkArr[0].id.toString();
        this.handlerGetFormConfig(Number(this.checkArr[0].id));
      } else if (this.currentTab == 2) {
        this.payConfigName = this.payConfigArr[0].extra;
        this.handlerGetFormConfig(Number(this.payConfigArr[0].extra));
      } else if (this.currentTab == 3) {
        this.siteConfigName = this.siteConfigArr[0].extra;
        this.handlerGetFormConfig(Number(this.siteConfigArr[0].extra));
      }
    },
    beforeStep: function beforeStep() {
      this.currentTab--;
      this.formConf.content = {
        fields: []
      };
      this.formConf.render = false;
      if (this.currentTab == 1) {
        this.applicationName = this.checkArr[0].id.toString();
        this.handlerGetFormConfig(Number(this.checkArr[0].id));
      } else if (this.currentTab == 2) {
        this.payConfigName = this.payConfigArr[0].extra;
        this.handlerGetFormConfig(Number(this.payConfigArr[0].extra));
      } else if (this.currentTab == 3) {
        this.siteConfigName = this.siteConfigArr[0].extra;
        this.handlerGetFormConfig(Number(this.siteConfigArr[0].extra));
      }
    },
    handleClick: function handleClick(tab) {
      var _id = tab.name ? tab.name : '';
      if (!_id) return this.$message.error('表单配置不正确，请关联正确表单后使用');
      this.handlerGetFormConfig(_id);
    },
    handlerGetFormConfig: function handlerGetFormConfig(id) {
      var _this = this;
      var formPram = {
        id: id
      };
      this.currentEditId = id;
      this.formConf.content = {
        fields: []
      };
      this.formConf.render = false;
      this.loading = true;
      systemFormConfigApi.getFormConfigInfo(formPram).then(function (data) {
        var id = data.id,
          name = data.name,
          info = data.info,
          content = data.content;
        _this.formConf.content = JSON.parse(content);
        _this.formConf.id = id;
        _this.handlerGetSettingInfo(id, 1);
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    handlerGetSettingInfo: function handlerGetSettingInfo(id, level) {
      var _this2 = this;
      systemSettingApi.systemConfigInfo({
        id: id
      }).then(function (data) {
        _this2.currentEditData = data;
        if (level === 1) {
          _this2.formConf.isEdit = _this2.currentEditData !== null;
          _this2.formConf.render = true;
        }
      });
    },
    handlerSubmit: (0, _validate.Debounce)(function (formValue) {
      this.handlerSave(formValue);
    }),
    handlerSave: function handlerSave(formValue) {
      var _this3 = this;
      var _pram = this.buildFormPram(formValue);
      var _formId = 0;
      systemSettingApi.systemConfigSave(_pram).then(function (data) {
        _this3.$message.success('添加数据成功');
      });
    },
    buildFormPram: function buildFormPram(formValue) {
      var _pram = {
        fields: [],
        id: this.currentEditId,
        sort: 0,
        // 参数暂时无用
        status: true // 参数暂时无用
      };
      var _fields = [];
      Object.keys(formValue).forEach(function (key) {
        _fields.push({
          name: key,
          title: key,
          value: formValue[key]
        });
      });
      _pram.fields = _fields;
      return _pram;
    },
    handlerGetTreeList: function handlerGetTreeList() {
      var _this4 = this;
      var _pram = {
        type: 6,
        status: 1
      };
      this.loading = true;
      categoryApi.treeCategroy(_pram).then(function (data) {
        _this4.payConfigArr = data[3].child;
        _this4.siteConfigArr[0] = data[0].child[0];
        _this4.loading = false;
      }).catch(function () {
        _this4.loading = false;
      });
    },
    formSubmit: (0, _validate.Debounce)(function (name) {
      var _this5 = this;
      this.formInline.account = this.formInline.phone;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this5.loading = true;
          (0, _sms.registerApi)(_this5.formInline).then(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _this5.$message.success('注册成功');
                    _this5.loading = false;
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function () {
            _this5.loading = false;
          });
        } else {
          return false;
        }
      });
    }),
    complate: function complate() {
      this.$cache.local.remove('step');
      this.$router.push('/');
    },
    cutDown: function cutDown() {
      var _this6 = this;
      if (this.formInline.phone) {
        if (!this.canClick) return;
        this.canClick = false;
        this.cutNUm = 60;
        (0, _sms.captchaApi)({
          phone: this.formInline.phone,
          types: 0
        }).then(/*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _this6.$message.success('发送成功');
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
        var time = setInterval(function () {
          _this6.cutNUm--;
          if (_this6.cutNUm === 0) {
            _this6.cutNUm = '获取验证码';
            _this6.canClick = true;
            clearInterval(time);
          }
        }, 1000);
      } else {
        this.$message.warning('请填写手机号!');
      }
    }
  }
};